import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { computed, ref } from 'vue';

interface AlertLink {
  href: string;
  text: string;
  target: '_blank' | '_self';
}

interface Props {
  icon?: Icons;
  text?: string;
  link?: AlertLink;
  description?: string;
  type?: 'error' | 'info';
  showMoreText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcAlert.ts',
  props: {
    icon: { default: 'lightBulb' },
    text: { default: 'A rule could make changes to this campaign if its condition is met.' },
    link: null,
    description: { default: '' },
    type: { default: 'info' },
    showMoreText: null
  },
  setup(__props: any) {

const props = __props as { icon: Icons, text: string, link?: AlertLink, description: string, type: 'error' | 'info', showMoreText?: string };



const activeShowMore = ref(false);

const textValue = computed(() => {
  if (activeShowMore.value) {
    return [props.text, props.showMoreText].join(' ');
  }
  return props.text;
});

return { __sfc: true,props, activeShowMore, textValue, CcIcon }
}

})